import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Image, MoreHoriz } from '@material-ui/icons'
import { Grid, Button, Typography } from '@material-ui/core'

import { mountUrl, getElasticFieldNameByLanguage, replaceImagePath } from '~/utils'
import { useSelector } from 'react-redux'
import { useIntersectionObserver } from '~/components/useIntersectionObserver'

export default function ProductCard({ product, productClick, getLiteral }) {
  const history = useHistory()
  const location = useLocation()
  const { language } = useSelector((state) => state.config)
  const { ref, isIntersecting } = useIntersectionObserver({
    threshold: 0.1,
    triggerOnce: true
  })

  const [hasBeenIntersecting, setHasBeenIntersecting] = useState(false)

  const productImage = replaceImagePath(product)

  useEffect(() => {
    if (isIntersecting) setHasBeenIntersecting(true)
  }, [isIntersecting])

  return (
    <>
      <Grid ref={ref} style={{ display: 'flex' }}>
        {hasBeenIntersecting &&
        (product.imageurl || product[getElasticFieldNameByLanguage(language, 'image_url')]) ? (
          <img
            src={mountUrl(productImage, { height: 100 })}
            width={80}
            height={80}
            alt={product[getElasticFieldNameByLanguage(language, 'description')]}
            style={{ border: '2px solid #c4c4c4', padding: 4 }}
          />
        ) : (
          <Grid
            style={{
              border: '2px solid #c4c4c4',
              padding: 4,
              height: 80,
              width: 80
            }}
          >
            <Image style={{ fontSize: 68, color: '#C4C4C4' }} />
          </Grid>
        )}
      </Grid>
      <Grid
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'space-around',
          marginLeft: 24,
          maxWidth: '100%'
        }}
      >
        <Typography
          style={{
            maxWidth: '100%',
            display: '-webkit-box',
            overflow: 'hidden',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,

            fontWeight: theme.typography.fontWeightMedium,
            fontSize: 16
          }}
        >
          {product[getElasticFieldNameByLanguage(language, 'name')]}
        </Typography>
        <Button
          fullWidth={false}
          variant="text"
          size="small"
          startIcon={<MoreHoriz color="error" />}
          style={{ paddingInline: 16 }}
          onClick={() => {
            productClick()
            history.push({
              pathname: `/produto/${product.gtin}/detalhes`,
              state: { fromApp: true, prevPath: location.pathname }
            })
          }}
        >
          <span style={{ textDecoration: 'underline' }}>{getLiteral('1005')}</span>
        </Button>
      </Grid>
    </>
  )
}
